class OverviewService {

}

export default new OverviewService();
